<template>
  <div class="flex w-full px-5">
    <div v-if="$store.state.auth.user.user_type !== 'end_user'" v-click-outside="clickOutsideFilter" class="ml-auto">
      <Menu v-slot="{ close }" ref="workspaceMenu" as="div" class="relative flex-shrink-0 ml-auto">
        <MenuButton>
          <button class="font-light btn cancel-btn">
            {{ $t("Showing") }} <span class="ml-1 font-bold">{{ $t(filter_text) }}</span>
          </button>
        </MenuButton>
        <transition
          enter-active-class="transition duration-100 ease-out"
          enter-from-class="transform scale-95 opacity-0"
          enter-to-class="transform scale-100 opacity-100"
          leave-active-class="transition duration-75 ease-in"
          leave-from-class="transform scale-100 opacity-100"
          leave-to-class="transform scale-95 opacity-0">
          <MenuItems
            class="absolute z-50 mx-3 -ml-[100px] w-[300px] origin-bottom-right bg-white border rounded-lg mt-1 focus:outline-none">
            <div v-if="$store.state.auth.user.user_type !== 'end_user'" class="relative flex items-stretch flex-grow m-2 focus-within:z-10">
              <div class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                <Search class="z-10 w-5 h-5 text-gray-400" aria-hidden="true" />
              </div>
              <TextInput
                v-model="search_term"
                input-classes="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md  placeholder-gray-400 focus:outline-none focus:ring-blue-light focus:border-blue-light sm:text-sm"
                name="workspace_search_term"
                type="text"
                :validate-on-input="true"
                :is-box-background="true"
                :label="$t('Search')"
                :icon="true" />
            </div>

            <div class="flex items-center p-2 space-x-10" @click="filter_by = 'all'">
              <input
                :disabled="true"
                :checked="filter_by == 'all'"
                type="checkbox"
                class="w-4 h-4 transition ease-in-out rounded pointer-events-none form-checkbox text-light-brand-blue dark:text-dark-brand-blue checked:bg-light-brand-blue dark:checked:bg-dark-brand-blue bg-light-box-background dark:bg-dark-box-background focus:ring-0 ring-dark/0 border-common-grey duration-side-menu-transition-duration">
              <div>{{ $t("View All") }}</div>
            </div>
            <div
              class="flex items-center p-2 space-x-10"
              @click="filter_by == 'me' && collaborators_selected ? (filter_by = null) : (filter_by = 'me')">
              <input
                :checked="filter_by == 'me'"
                disabled
                type="checkbox"
                class="w-4 h-4 transition ease-in-out rounded pointer-events-none form-checkbox text-light-brand-blue dark:text-dark-brand-blue checked:bg-light-brand-blue dark:checked:bg-dark-brand-blue bg-light-box-background dark:bg-dark-box-background focus:ring-0 ring-dark/0 border-common-grey duration-side-menu-transition-duration">
              <div>{{ $t("Created by me") }}</div>
            </div>

            <div v-for="collaborator in selected_collaborators" :key="collaborator.id" class="my-3 ml-2">
              <input
                :checked="true"
                type="checkbox"
                class="w-4 h-4 transition ease-in-out rounded form-checkbox mr-9 text-light-brand-blue dark:text-dark-brand-blue checked:bg-light-brand-blue dark:checked:bg-dark-brand-blue bg-light-box-background dark:bg-dark-box-background focus:ring-0 ring-dark/0 border-common-grey duration-side-menu-transition-duration"
                @input="(e) => handleSelectCollaborator(e, collaborator)">
              {{ collaborator.first_name ? `${collaborator.first_name} ${collaborator.last_name}` : `${collaborator.name}` }}
            </div>

            <div class="ml-2">
              <div
                v-for="collaborator in filtered_collaborators.filter((c) => !selected_collaborators.find((s_c) => s_c.id == c.id))"
                :key="collaborator.id"
                class="my-3">
                <input
                  :checked="selected_collaborators.find((c) => c.id == collaborator)"
                  type="checkbox"
                  class="w-4 h-4 transition ease-in-out rounded form-checkbox mr-9 text-light-brand-blue dark:text-dark-brand-blue checked:bg-light-brand-blue dark:checked:bg-dark-brand-blue bg-light-box-background dark:bg-dark-box-background focus:ring-0 ring-dark/0 border-common-grey duration-side-menu-transition-duration"
                  @input="(e) => handleSelectCollaborator(e, collaborator)">
                {{ collaborator.first_name ? `${collaborator.first_name} ${collaborator.last_name}` : `${collaborator.name}` }}
              </div>
            </div>
            <div class="flex w-full pr-2 my-2 space-x-2">
              <button class="ml-2 w-1/2 btn primary-btn" @click="handleApplyFilters(close)">{{ $t("Apply Filters") }}</button>
              <button
                class="w-1/2 btn cancel-btn"
                @click="
                  () => {
                    close()
                    filter_by = 'all'
                    filter_text = 'all'
                  }
                ">
                {{ filter_text == "all" ? $t("Cancel") : $t("Clear filters") }}
              </button>
            </div>
          </MenuItems>
        </transition>
      </Menu>
    </div>
    <div class="ml-2" :class="[{ 'ml-auto': $store.state.auth.user.user_type == 'end_user' }]">
      <Menu ref="workspaceMenu" as="div" class="relative flex-shrink-0 ml-auto">
        <MenuButton>
          <button class="font-light btn cancel-btn">
            {{ $t("Sorted by") }} <span class="ml-1 font-bold">{{ $t(sorted_by.replaceAll("_", " ")) }}</span>
          </button>
        </MenuButton>
        <transition
          enter-active-class="transition duration-100 ease-out"
          enter-from-class="transform scale-95 opacity-0"
          enter-to-class="transform scale-100 opacity-100"
          leave-active-class="transition duration-75 ease-in"
          leave-from-class="transform scale-100 opacity-100"
          leave-to-class="transform scale-95 opacity-0">
          <MenuItems
            class="absolute z-50 mx-3 -ml-[127px] w-[300px] origin-bottom-right bg-white border rounded-lg mt-1 focus:outline-none">
            <div
              v-if="$store.state.auth.user.user_type !== 'end_user'"
              class="flex items-center p-2 space-x-5 cursor-pointer"
              @click="sorted_by = 'access_date'">
              <input
                v-if="sorted_by == 'access_date'"
                :disabled="true"
                :checked="sorted_by == 'access_date'"
                type="checkbox"
                class="w-4 h-4 transition ease-in-out rounded pointer-events-none form-checkbox text-light-brand-blue dark:text-dark-brand-blue checked:bg-light-brand-blue dark:checked:bg-dark-brand-blue bg-light-box-background dark:bg-dark-box-background focus:ring-0 ring-dark/0 border-common-grey duration-side-menu-transition-duration">
              <div :class="[{ 'ml-3': sorted_by !== 'access_date' }]">
                {{ $t("Access date") }}
              </div>
            </div>

            <div class="flex items-center p-2 space-x-5 cursor-pointer" @click="sorted_by = 'edit_date'">
              <input
                v-if="sorted_by == 'edit_date'"
                :disabled="true"
                :checked="sorted_by == 'edit_date'"
                type="checkbox"
                class="w-4 h-4 transition ease-in-out rounded pointer-events-none form-checkbox text-light-brand-blue dark:text-dark-brand-blue checked:bg-light-brand-blue dark:checked:bg-dark-brand-blue bg-light-box-background dark:bg-dark-box-background focus:ring-0 ring-dark/0 border-common-grey duration-side-menu-transition-duration">
              <div :class="[{ 'ml-3': sorted_by !== 'edit_date' }]">
                {{ $t("Edit date") }}
              </div>
            </div>

            <div class="flex items-center p-2 space-x-5 cursor-pointer" @click="sorted_by = 'alphabetical'">
              <input
                v-if="sorted_by == 'alphabetical'"
                :disabled="true"
                :checked="sorted_by == 'alphabetical'"
                type="checkbox"
                class="w-4 h-4 transition ease-in-out rounded pointer-events-none form-checkbox text-light-brand-blue dark:text-dark-brand-blue checked:bg-light-brand-blue dark:checked:bg-dark-brand-blue bg-light-box-background dark:bg-dark-box-background focus:ring-0 ring-dark/0 border-common-grey duration-side-menu-transition-duration">
              <div :class="[{ 'ml-3': sorted_by !== 'alphabetical' }]">
                {{ $t("Alphabetical") }}
              </div>
            </div>
          </MenuItems>
        </transition>
      </Menu>
    </div>
  </div>
</template>

<script>
import { Search } from "lucide-vue-next"

import { Menu, MenuButton, MenuItems } from "@headlessui/vue"
import TextInput from "@/components/shared/TextInput.vue"
import dataService from "@/services/data.service"

export default {
  components: { Menu, MenuButton, MenuItems, TextInput, Search },

  props: {},
  emits: ["update:filtersAndSorting"],
  data() {
    return {
      search_term: "",
      filter_text: "all",
      filtered_collaborators: [],
      selected_collaborators: [],
      selected_collaborators_backup: [],
      sorted_by: "access_date",
      filter_by: "all",
      filter_by_backup: "all",
      mounted: false
    }
  },
  computed: {
    showing_text_calc() {
      let text = ""
      if (this.filter_by == "all") {
        text = this.$t("all")
        return text
      } else {
        if (this.filter_by == "me") {
          if (text) {
            text += " & me"
          } else {
            text = this.$t("Created by me")
          }
        }
        if (this.selected_collaborators.length) {
          const no_of_collaborators_selected = this.selected_collaborators.length
          if (text) {
            text += ` & ${
              no_of_collaborators_selected == 1
                ? this.selected_collaborators[0]?.first_name
                  ? this.selected_collaborators[0]?.first_name
                  : this.selected_collaborators[0]?.name.split(" ")[0]
                : `${no_of_collaborators_selected} ` + this.$t("collaborators")
            }`
          } else {
            text = ` ${
              no_of_collaborators_selected == 1
                ? this.selected_collaborators[0]?.first_name
                  ? this.selected_collaborators[0]?.first_name
                  : this.selected_collaborators[0]?.name.split(" ")[0]
                : `${no_of_collaborators_selected} ` + this.$t("collaborators")
            }`
          }
        }
        return text
      }
    },
    collaborators_selected() {
      return this.selected_collaborators.length
    }
  },
  watch: {
    filter_text() {
      this.selected_collaborators_backup = this.$utils.clone(this.selected_collaborators)
      this.filter_by_backup = this.filter_by
      this.filterWorkspaces()

      //getWorkpaces
    },
    search_term() {
      const params = { q: this.search_term }
      if (this.$store.state.auth.user.user_type == "user") {
        dataService.getWorkspaceCollaborators(params).then((res) => {
          this.filtered_collaborators = res.data.team_members
            .filter((t) => t.id !== this.$store.state.auth.user.id)
            .concat(res.data.contacts)
        })
      }
    },
    filter_by() {
      if (this.filter_by == "all") {
        this.search_term = ""
        this.selected_collaborators = []
      }
    },

    selected_collaborators: {
      deep: true,
      handler() {
        if (this.selected_collaborators.length && this.filter_by == "all") {
          this.filter_by = null
        }
        if (!this.selected_collaborators.length && !this.filter_by) {
          this.filter_by = "all"
        }
      }
    },
    sorted_by() {
      this.filterWorkspaces()
    }
  },

  beforeUnmount() {
    this.mounted = false
  },
  created() {
    setTimeout(() => {
      this.mounted = true
    }, 500)
    if (this.$store.state.auth.user.user_type !== "end_user") {
      dataService.getWorkspaceCollaborators().then((res) => {
        this.filtered_collaborators = res.data.team_members.filter((t) => t.id !== this.$store.state.auth.user.id).concat(res.data.contacts)
      })
    }
  },

  methods: {
    clickOutsideFilter() {
      this.filter_by = this.filter_by_backup

      setTimeout(() => {
        if (this.mounted) {
          this.selected_collaborators = [...this.selected_collaborators_backup]
        }
      }, 700)
    },
    handleApplyFilters(close) {
      this.filter_text = this.showing_text_calc
      if (close) {
        close()
      }
    },
    filterWorkspaces() {
      this.$emit("update:filtersAndSorting", {
        filter_by: this.filter_by,
        filtered_collaborators: this.selected_collaborators,
        sort_by: this.sorted_by
      })
    },

    handleSelectCollaborator(e, collaborator) {
      const index = this.selected_collaborators.findIndex((c) => c.id == collaborator.id)
      if (index !== -1) {
        this.selected_collaborators.splice(index, 1)
      } else {
        this.selected_collaborators.push(collaborator)
      }
    }
  }
}
</script>
